import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, total, pageSize = 20, onPage, testid = "pagination" }) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);

  // windowed page numbers
  const pages = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(pageCount, start + 4);
  for (let p = Math.max(1, end - 4); p <= end; p++) pages.push(p);

  return (
    <div className="mt-4 flex items-center justify-between gap-3 flex-wrap" data-testid={testid}>
      <div className="text-xs text-muted-foreground" data-testid={`${testid}-info`}>
        Showing {from}–{to} of {total}
      </div>
      {pageCount > 1 && (
        <div className="flex items-center gap-1">
          <button
            onClick={() => onPage(page - 1)}
            disabled={page === 1}
            className="h-8 w-8 grid place-items-center border border-border disabled:opacity-40 hover:bg-muted transition-colors"
            data-testid={`${testid}-prev`}
          ><ChevronLeft className="h-4 w-4" /></button>
          {pages.map((p) => (
            <button
              key={p}
              onClick={() => onPage(p)}
              className={`h-8 min-w-8 px-2 grid place-items-center border text-xs font-bold font-mono-num transition-colors ${p === page ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted"}`}
              data-testid={`${testid}-page-${p}`}
            >{p}</button>
          ))}
          <button
            onClick={() => onPage(page + 1)}
            disabled={page === pageCount}
            className="h-8 w-8 grid place-items-center border border-border disabled:opacity-40 hover:bg-muted transition-colors"
            data-testid={`${testid}-next`}
          ><ChevronRight className="h-4 w-4" /></button>
        </div>
      )}
    </div>
  );
}
